<template>
    <section id="mobile-application" class="bg-main h-auto py-5">
        <!-- Mobile App Section Start -->
        <div class="container-fluid vh-110 d-flex flex-column align-items-center justify-content-center pb-5 pb-lg-0">
            <div class="container d-flex justify-content-center position-relative pt-lg-5 pb-4 pb-md-5 pb-lg-0">
                <div class="d-none d-lg-flex flex-column justify-content-between gap-4">
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/coins.svg"
                            alt="kovanice"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Program sa poenima</strong>
                        <p>Skupljaš poene pri svakoj kupovini, napreduješ kroz tri nivoa u zavisnosti od potrošnje i koristiš poene za umanjenje računa. Što viši nivo dostigneš, veće pogodnosti uživaš.</p>
                    </div>
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/qr_code.svg"
                            alt="qr kod"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Skeniraj i plati - Drive Thru</strong>
                        <p>Nova aplikacija omogućava plaćanje goriva bez odlaska na kasu, skeniranjem QR koda koji se nalazi kod točionog aparata.</p>
                    </div>
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/coupon.svg"
                            alt="kupon"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Moji kuponi</strong>
                        <p>Nova verzija Euro Petrol aplikacije donosi ti još jednu važnu pogodnost, mogućnost da ostvariš kupon za gratis proizvod.</p>
                    </div>
                </div>
                <swiper class="w-phone zi-top my-lg-auto position-relative" :grabCursor="true" :effect="'flip'" @swiper="onSwiper" :autoplay='{"delay": 4000, "disableOnInteraction": false }'>
                  <swiper-slide>
                    <a href="https://play.google.com/store/apps/details?id=com.europetrol.epk" target="_blank" rel="noopener" aria-label="iOS Mobile App" class="d-flex flex-column align-items-center">
                        <img src="/img/landing_page/application_on_mobile_1.webp" class="img-fluid w-100 position-relative" alt="" srcset="">
                    </a>
                  </swiper-slide>

                  <swiper-slide>
                    <a href="https://apps.apple.com/us/app/euro-petrol/id1459216332" target="_blank" rel="noopener" aria-label="Android Mobile App" class="d-flex flex-column align-items-center">
                        <img src="/img/landing_page/application_on_mobile_2.webp" class="img-fluid w-100 position-relative" alt="" srcset="">
                    </a>
                  </swiper-slide>
                </swiper>
                <div class="d-none d-lg-flex flex-column justify-content-between gap-4">
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/discount.svg"
                            alt="popust"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Program sa dinarskim popustom</strong>
                        <p>Ostvaruješ automatski popust pri svakoj kupovini prema važećoj skali popusta, kao i u dosadašnjoj verziji aplikacije. Iznos popusta je uvek isti i ne menja se u zavisnosti od tvoje potrošnje.</p>
                    </div>
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/car.svg"
                            alt="automobil"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Moj auto</strong>
                        <p>Sekcija „Moj auto” omogućava ti da u aplikaciji sačuvaš osnovne podatke o svom vozilu i na jednom mestu pratiš sve važne informacije.</p>
                    </div>
                    <div class="d-flex flex-column">
                        <img
                            width="40"
                            height="40"
                            src="/img/landing_page/app_section_icons/wallet.svg"
                            alt="novačnik"
                        />
                        <strong class="fs-5 fs-xl-4 mt-2">Praćenje potrošnje i uštede</strong>
                        <p>U aplikaciji možeš pratiti sve svoje transakcije i ostvarene uštede. Za svaku kupovinu dobijaš PDF račun koji je uvek dostupan u aplikaciji i možeš ga preuzeti kada god ti zatreba. </p>
                    </div>
                </div>
            </div>
            <div class="d-lg-none d-flex flex-column justify-content-center w-100">
                <div class="d-flex justify-content-center flex-wrap gap-3">
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(0)">
                        <div
                            class="text-node-icon active mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/coins.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/coins.svg');
                            "
                            aria-label="kovanice"
                        ></div>
                    </div>
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(1)">
                        <div
                            class="text-node-icon mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/qr_code.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/qr_code.svg');
                            "
                            aria-label="qr kod"
                        ></div>
                    </div>
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(2)">
                        <div
                            class="text-node-icon mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/coupon.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/coupon.svg');
                            "
                            aria-label="kupon"
                        ></div>
                    </div>
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(3)">
                        <div
                            class="text-node-icon mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/discount.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/discount.svg');
                            "
                            aria-label="popust"
                        ></div>
                    </div>
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(4)">
                        <div
                            class="text-node-icon mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/car.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/car.svg');
                            "
                            aria-label="automobil"
                        ></div>
                    </div>
                    <div class="text-node p-2 p-md-2.5" @click.stop.capture="showText(5)">
                        <div
                            class="text-node-icon mask-center"
                            style="
                                mask-image: url('/img/landing_page/app_section_icons/wallet.svg');
                                -webkit-mask-image: url('/img/landing_page/app_section_icons/wallet.svg');
                            "
                            aria-label="novačnik"
                        ></div>
                    </div>
                </div>
                <h4 class="text-light mt-3 text-center fs-3 fw-bold">{{ titleText }}</h4>
                <div class="w-100 d-flex justify-content-center">
                    <p class="w-text d-flex text-center">{{ descriptionText }}</p>
                </div>
            </div>
        </div>
        <!-- Mobile App Section End -->
    </section>
</template>

<script>
  // Import Swiper Vue.js components
  import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
  import SwiperCore, {Autoplay,EffectFlip} from 'swiper';

  // install Swiper modules
  SwiperCore.use([Autoplay,EffectFlip]);

  // Import Swiper styles
  import "swiper/swiper-bundle.css";

  import { ref, onMounted, computed } from 'vue';

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },
    setup() {
      const onSwiper = (swiper) => {
          return{
              swiper,
              autoplay: {
                  delay: 1000
              },
          };
      };

      const textNodes = ref([
        {
          title: "Program sa poenima",
          description: `
            Skupljaš poene pri svakoj kupovini, napreduješ kroz tri nivoa u zavisnosti od potrošnje i koristiš poene za umanjenje računa. Što viši nivo dostigneš, veće pogodnosti uživaš.
          `,
        },
        {
          title: "Skeniraj i plati - Drive Thru",
          description: `
            Nova aplikacija omogućava plaćanje goriva bez odlaska na kasu, skeniranjem QR koda koji se nalazi kod točionog aparata.
          `,
        },
        {
          title: "Moji kuponi",
          description: `
            Nova verzija Euro Petrol aplikacije donosi ti još jednu važnu pogodnost, mogućnost da ostvariš kupon za gratis proizvod.
          `,
        },
        {
          title: "Program sa dinarskim popustom",
          description: `
            Ostvaruješ automatski popust pri svakoj kupovini prema važećoj skali popusta, kao i u dosadašnjoj verziji aplikacije. Iznos popusta je uvek isti i ne menja se u zavisnosti od tvoje potrošnje.
          `,
        },
        {
          title: "Moj auto",
          description: `
            Sekcija „Moj auto” omogućava ti da u aplikaciji sačuvaš osnovne podatke o svom vozilu i na jednom mestu pratiš sve važne informacije.
          `,
        },
        {
          title: "Praćenje potrošnje i uštede",
          description: `
            U aplikaciji možeš pratiti sve svoje transakcije i ostvarene uštede. Za svaku kupovinu dobijaš PDF račun koji je uvek dostupan u aplikaciji i možeš ga preuzeti kada god ti zatreba.
          `,
        },
      ]);

      const selectedNode = ref(0);

      function showText(index) {
        selectedNode.value = index;

        document.querySelectorAll(".text-node-icon").forEach((node, i) => {
          if (i != index) {
            node.classList.remove("active");
            return;
          }

          node.classList.add("active");
        });
      }

      const titleText = computed(() => textNodes.value[selectedNode.value].title);
      const descriptionText = computed(() => textNodes.value[selectedNode.value].description);

      return {
          onSwiper,
          showText,
          titleText,
          descriptionText
      };
    },
  };
</script>

<style scoped>
@import "../../assets/variables.css";

.text-node {
    cursor: pointer;
}

.text-node-icon {
    width: 2.25rem;
    height: 2.25rem;
    background-color: white;
}

.text-node-icon.active {
    background-color: var(--color-secondary);
}

.number {
    color: var(--color-main);
    width: 45px;
    height: 45px;
    border-radius: 50%;
}

.bottom-icon{
    bottom: -60px;
    position: absolute;
}

.w-text {
    width: 350px;
}

.vh-110{
    height: 110vh;
}

.w-phone {
    width: 35%;
}

.fs-20{
    font-size: 20px;
}

.mask-center {
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
}

@media (max-width: 991px) {
    .w-phone {
        width: 60%;
        left: -40px;
    }

    .w-75 {
        width: 50% !important;
    }
}

@media (min-width: 768px) {
    .p-md-2\.5 {
        padding: 0.75rem !important;
    }
}

@media (max-width: 767px) {
    .w-phone {
        width: 38vh;
        left: 0;
    }

    .bottom-icon{
        position: initial;
        margin-top: 20px;
    }

    .text-node-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .w-75 {
        width: 75% !important;
    }

    .vh-110{
        height: auto;
    }
}
</style>
